var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "content-header row d-print-none" }, [
      _c("div", { staticClass: "content-header-left col-md-7 col-12 mb-2" }, [
        _c("div", { staticClass: "row breadcrumbs-top" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("h2", { staticClass: "content-header-title float-left mb-0" }, [
              _vm._v("Reconciliation Detail")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "breadcrumb-wrapper col-12" }, [
              _c("ol", { staticClass: "breadcrumb" }, [
                _c(
                  "li",
                  { staticClass: "breadcrumb-item" },
                  [
                    _c("router-link", { attrs: { to: "/home" } }, [
                      _vm._v(_vm._s(_vm.trans("general.home")))
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "breadcrumb-item" },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: "/monnify-reconciliation" } },
                      [_vm._v("Monnify Reconciliation")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("li", { staticClass: "breadcrumb-item active" }, [
                  _vm._v("Detail")
                ])
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "content-header-right text-md-right col-md-5 col-12 d-md-block d-none"
        },
        [
          _c(
            "button",
            {
              staticClass: "btn btn-outline-secondary btn-sm mr-1",
              on: { click: _vm.printPage }
            },
            [_c("i", { staticClass: "feather icon-printer" }), _vm._v(" Print")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-primary btn-sm",
              on: {
                click: function($event) {
                  return _vm.$router.push("/monnify-reconciliation")
                }
              }
            },
            [_c("i", { staticClass: "feather icon-list" }), _vm._v(" Back")]
          )
        ]
      )
    ]),
    _vm._v(" "),
    _vm.row
      ? _c("div", { staticClass: "content-body" }, [
          _c("div", { staticClass: "alert alert-warning d-print-none" }, [
            _vm._v(
              "This page is read-only and does not correct payment, invoice, or receipt records."
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-4" }, [
              _c("div", { staticClass: "card h-100" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "card-body" }, [
                  _c("dl", { staticClass: "detail-list" }, [
                    _c("dt", [_vm._v("Transaction Reference")]),
                    _c("dd", [
                      _vm._v(_vm._s(_vm.row.transaction_reference || "-"))
                    ]),
                    _vm._v(" "),
                    _c("dt", [_vm._v("Session ID")]),
                    _c("dd", [_vm._v(_vm._s(_vm.row.session_id || "-"))]),
                    _vm._v(" "),
                    _c("dt", [_vm._v("Account Transaction ID")]),
                    _c("dd", [
                      _vm._v(_vm._s(_vm.row.account_transaction_id || "-"))
                    ]),
                    _vm._v(" "),
                    _c("dt", [_vm._v("Transaction Record ID")]),
                    _c("dd", [
                      _vm._v(_vm._s(_vm.row.transaction_record_id || "-"))
                    ]),
                    _vm._v(" "),
                    _c("dt", [_vm._v("Source Account Name")]),
                    _c("dd", [
                      _vm._v(_vm._s(_vm.row.source_account_name || "-"))
                    ]),
                    _vm._v(" "),
                    _c("dt", [_vm._v("Expected Application Amount")]),
                    _c("dd", [_vm._v(_vm._s(_vm.expectedAmount))]),
                    _vm._v(" "),
                    _c("dt", [_vm._v("Amount Paid")]),
                    _c("dd", [
                      _vm._v(_vm._s(_vm._f("formatMoney")(_vm.row.amount_paid)))
                    ]),
                    _vm._v(" "),
                    _c("dt", [_vm._v("Difference")]),
                    _c("dd", [_vm._v(_vm._s(_vm.differenceAmount))]),
                    _vm._v(" "),
                    _c("dt", [_vm._v("Monnify Created Date")]),
                    _c("dd", [
                      _vm._v(_vm._s(_vm.row.external_created_on || "-"))
                    ]),
                    _vm._v(" "),
                    _c("dt", [_vm._v("Rejection Reason")]),
                    _c("dd", [_vm._v(_vm._s(_vm.row.rejection_reason || "-"))]),
                    _vm._v(" "),
                    _c("dt", [_vm._v("Refund Status")]),
                    _c("dd", [
                      _c(
                        "span",
                        {
                          class: _vm.refundClass(_vm.row.refund_status_category)
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.row.refund_status ||
                                "Unavailable in source file"
                            )
                          )
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("h5", [_vm._v("Original Row")]),
                  _vm._v(" "),
                  _c("pre", { staticClass: "payload-box" }, [
                    _vm._v(_vm._s(_vm.rawRow))
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-4" }, [
              _c("div", { staticClass: "card h-100" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "card-body" }, [
                  _c("dl", { staticClass: "detail-list" }, [
                    _c("dt", [_vm._v("Payment ID")]),
                    _c("dd", [_vm._v(_vm._s(_vm.paymentValue("id") || "-"))]),
                    _vm._v(" "),
                    _c("dt", [_vm._v("Invoice Number")]),
                    _c("dd", [
                      _vm._v(_vm._s(_vm.paymentValue("invoice_no") || "-"))
                    ]),
                    _vm._v(" "),
                    _c("dt", [_vm._v("Application Transaction")]),
                    _c("dd", [_vm._v(_vm._s(_vm.paymentValue("trx") || "-"))]),
                    _vm._v(" "),
                    _c("dt", [_vm._v("Application Reference")]),
                    _c("dd", [
                      _vm._v(_vm._s(_vm.paymentValue("reference") || "-"))
                    ]),
                    _vm._v(" "),
                    _c("dt", [_vm._v("RRR")]),
                    _c("dd", [_vm._v(_vm._s(_vm.paymentValue("rrr") || "-"))]),
                    _vm._v(" "),
                    _c("dt", [_vm._v("Current Payment Status")]),
                    _c("dd", [
                      _vm._v(_vm._s(_vm.row.current_payment_status || "-"))
                    ]),
                    _vm._v(" "),
                    _c("dt", [_vm._v("Current Invoice Status")]),
                    _c("dd", [
                      _vm._v(_vm._s(_vm.row.current_invoice_status || "-"))
                    ]),
                    _vm._v(" "),
                    _c("dt", [_vm._v("Payment Amount")]),
                    _c("dd", [_vm._v(_vm._s(_vm.paymentAmount))]),
                    _vm._v(" "),
                    _c("dt", [_vm._v("Paid On")]),
                    _c("dd", [
                      _vm._v(_vm._s(_vm.paymentValue("paid_on") || "-"))
                    ]),
                    _vm._v(" "),
                    _c("dt", [_vm._v("Payer")]),
                    _c("dd", [
                      _vm._v(
                        _vm._s(
                          _vm.paymentValue("payer_name") ||
                            _vm.row.payer_name ||
                            "-"
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("dt", [_vm._v("Institution")]),
                    _c("dd", [_vm._v(_vm._s(_vm.institutionName))]),
                    _vm._v(" "),
                    _c("dt", [_vm._v("Receipt")]),
                    _c("dd", [
                      _vm._v(
                        _vm._s(
                          _vm.row.receipt_number ||
                            "Receipt relationship not confirmed"
                        )
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("h5", [_vm._v("Payment Items")]),
                  _vm._v(" "),
                  _vm.paymentItems.length
                    ? _c(
                        "table",
                        { staticClass: "table table-sm table-bordered" },
                        [
                          _vm._m(2),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            _vm._l(_vm.paymentItems, function(item) {
                              return _c("tr", { key: item.id }, [
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      item.pay_item
                                        ? item.pay_item.name
                                        : item.description
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(_vm._f("formatMoney")(item.amount))
                                  )
                                ])
                              ])
                            }),
                            0
                          )
                        ]
                      )
                    : _c("p", { staticClass: "text-muted" }, [
                        _vm._v("No payment items found.")
                      ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-4" }, [
              _c("div", { staticClass: "card h-100" }, [
                _vm._m(3),
                _vm._v(" "),
                _c("div", { staticClass: "card-body" }, [
                  _c("dl", { staticClass: "detail-list" }, [
                    _c("dt", [_vm._v("Match Method")]),
                    _c("dd", [_vm._v(_vm._s(_vm.row.match_method || "-"))]),
                    _vm._v(" "),
                    _c("dt", [_vm._v("Match Status")]),
                    _c("dd", [_vm._v(_vm._s(_vm.row.match_status || "-"))]),
                    _vm._v(" "),
                    _c("dt", [_vm._v("Classification")]),
                    _c("dd", [
                      _c(
                        "span",
                        {
                          class: _vm.classificationClass(
                            _vm.displayClassification
                          )
                        },
                        [_vm._v(_vm._s(_vm.displayClassification))]
                      )
                    ]),
                    _vm._v(" "),
                    _c("dt", [_vm._v("Eligibility")]),
                    _c("dd", [
                      _vm._v(_vm._s(_vm.row.eligibility_status || "-"))
                    ]),
                    _vm._v(" "),
                    _c("dt", [_vm._v("Exception")]),
                    _c("dd", [_vm._v(_vm._s(_vm.row.exception_reason || "-"))]),
                    _vm._v(" "),
                    _c("dt", [_vm._v("Recommended Future Action")]),
                    _c("dd", [
                      _vm._v(_vm._s(_vm.row.recommended_action || "-"))
                    ]),
                    _vm._v(" "),
                    _c("dt", [_vm._v("Calculated Classification")]),
                    _c("dd", [
                      _vm._v(_vm._s(_vm.row.calculated_classification || "-"))
                    ]),
                    _vm._v(" "),
                    _c("dt", [_vm._v("Classification Agreement")]),
                    _c("dd", [
                      _vm._v(
                        _vm._s(_vm.row.classification_agreement_status || "-")
                      )
                    ]),
                    _vm._v(" "),
                    _c("dt", [_vm._v("Duplicate Source Reference")]),
                    _c("dd", [
                      _vm._v(
                        _vm._s(
                          _vm.row.is_duplicate_source_reference
                            ? _vm.row.source_reference_row_count + " rows"
                            : "No"
                        )
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "comparison-box",
                      class: { ok: _vm.row.match_method === "payments.trx" }
                    },
                    [
                      _vm._v(
                        "\n                            Reference match: " +
                          _vm._s(
                            _vm.row.match_method === "payments.trx"
                              ? "Primary payments.trx match"
                              : "Not primary payments.trx match"
                          ) +
                          "\n                        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "comparison-box",
                      class: {
                        warn:
                          _vm.row.match_status !== "unmatched" &&
                          _vm.row.difference_amount > 0
                      }
                    },
                    [
                      _vm._v(
                        "\n                            Amount comparison: " +
                          _vm._s(_vm.amountComparisonText) +
                          "\n                        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "comparison-box",
                      class: {
                        warn:
                          _vm.row.current_payment_status === "success" ||
                          _vm.row.current_payment_status === "PAID"
                      }
                    },
                    [
                      _vm._v(
                        "\n                            Status comparison: " +
                          _vm._s(_vm.row.current_payment_status || "Unknown") +
                          "\n                        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "comparison-box",
                      class: { warn: _vm.row.receipt_number }
                    },
                    [
                      _vm._v(
                        "\n                            Receipt relationship: " +
                          _vm._s(_vm.row.receipt_number || "Not confirmed") +
                          "\n                        "
                      )
                    ]
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _vm.duplicateRows.length
            ? _c("div", { staticClass: "card mt-2" }, [
                _vm._m(4),
                _vm._v(" "),
                _c("div", { staticClass: "card-body" }, [
                  _c("div", { staticClass: "alert alert-info" }, [
                    _vm._v(
                      "\n                    Duplicate source rows are retained separately and are not automatically merged or selected for correction.\n                "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "table-responsive" }, [
                    _c(
                      "table",
                      {
                        staticClass: "table table-sm table-bordered text-nowrap"
                      },
                      [
                        _vm._m(5),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          _vm._l(_vm.duplicateRows, function(duplicate) {
                            return _c("tr", { key: duplicate.id }, [
                              _c("td", [
                                _vm._v(_vm._s(duplicate.source_row_number))
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(duplicate.session_id || "-"))
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(duplicate.external_created_on || "-")
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("formatMoney")(duplicate.amount_paid)
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(duplicate.source_account_name || "-")
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    duplicate.refund_status || "Unavailable"
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(duplicate.match_method || "-") +
                                    " / " +
                                    _vm._s(duplicate.match_status || "-")
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    duplicate.duplicate_group_has_different_amounts
                                      ? "Yes"
                                      : "No"
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    duplicate.duplicate_group_has_different_payer_names
                                      ? "Yes"
                                      : "No"
                                  )
                                )
                              ])
                            ])
                          }),
                          0
                        )
                      ]
                    )
                  ])
                ])
              ])
            : _vm._e()
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header" }, [
      _c("h4", { staticClass: "card-title mb-0" }, [
        _vm._v("Monnify Spreadsheet Data")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header" }, [
      _c("h4", { staticClass: "card-title mb-0" }, [_vm._v("Application Data")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [_c("th", [_vm._v("Item")]), _c("th", [_vm._v("Amount")])])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header" }, [
      _c("h4", { staticClass: "card-title mb-0" }, [_vm._v("Comparison")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header" }, [
      _c("h4", { staticClass: "card-title mb-0" }, [
        _vm._v("Duplicate Source Rows For This Reference")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Source Row")]),
        _c("th", [_vm._v("Session ID")]),
        _c("th", [_vm._v("Created On")]),
        _c("th", [_vm._v("Amount Paid")]),
        _c("th", [_vm._v("Source Name")]),
        _c("th", [_vm._v("Refund")]),
        _c("th", [_vm._v("Match")]),
        _c("th", [_vm._v("Different Amounts")]),
        _c("th", [_vm._v("Different Names")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }